import React, { Component } from 'react';
import {Icon, Menu} from "semantic-ui-react";

export default class ImpersonationBar extends Component {

    constructor(props) {
        super(props);

        var contact_id = "";
        if (sessionStorage.getItem("contact_id")) {
            contact_id = sessionStorage.getItem("contact_id");
        }
    
        var full_name = "";
        if (sessionStorage.getItem("full_name")) {
            full_name = sessionStorage.getItem("full_name");
        }

        var showImpersonationBar = false;
        if (sessionStorage.getItem("isImpersonating")) {
            showImpersonationBar = sessionStorage.getItem("isImpersonating") === 'true' ? true : false;
        }

        this.state = {
            showImpersonationBar: showImpersonationBar, 
            contact_id: contact_id,
            full_name: full_name
        }
    }

    render() {
        const {showImpersonationBar} = this.state;
        
        return (  
            showImpersonationBar ?
                <Menu color="yellow" inverted secondary className="nopadding">
                    <Menu.Item>
                    <Icon name='user secret' size='big' />
                    <span> Impersonation Mode: You are logged in as {this.state.full_name} (ContactID: {this.state.contact_id})</span>
                    </Menu.Item>            
                </Menu>
            : null   
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/ImpersonationBar/index.js